import styled from 'styled-components';

export const StyledButton = styled.button<{ size: 'sm' | 'md' }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${({ size }) => (size === 'sm' ? 'height: 44px;' : 'height: 5.3rem;')};
  border-radius: 0.8rem;
  background-color: var(--color-point);
  color: var(--color-white);

  &:disabled {
    background-color: var(--color-gray) !important;
    color: var(--color-gray-text);
  }

  &.anti {
    background-color: var(--color-gray);
  }

  &.transparent {
    background-color: transparent;
    color: var(--color-gray-text-second);
  }

  &.danger {
    background-color: #e13a3a;
    color: ${({ theme }) => theme.palette.gray15};
  }
`;
